import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { isJobDone } from 'lib/helpers'
import { generateChartData } from 'lib/chartHelpers'
import { Line } from 'react-chartjs-2'
import { BeatLoader } from 'react-spinners'

class CellsPerPositionGraph extends React.Component {
  static propTypes = {
    job: PropTypes.shape({}),
    augmentedJob: PropTypes.shape({}),
    loadImagesForJob: PropTypes.func
  }

  static defaultProps = {
    job: {},
    augmentedJob: {},
    loadImagesForJob: _.noop
  }

  componentDidMount () {
    const { job, loadImagesForJob } = this.props
    if (job.job_id && isJobDone(job)) {
      loadImagesForJob(job.job_id)
    }
  }

  render () {
    const { job, augmentedJob } = this.props
    let chartData = null
    if (augmentedJob) {
      chartData = generateChartData(augmentedJob).wbcChartData
    }
    const chartOptions = {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              stepSize: 100
            }
          }
        ]
      }
    }
    return (
      <div>
        {
          isJobDone(job) && augmentedJob && chartData && chartData.labels ? (
            <div>
              <div>{ job.jobId }</div>
              <div
                style={{
                  marginTop: 5,
                  marginBottom: 5,
                  maxWidth: 300,
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }}
              >
                <Line
                  data={chartData}
                  options={chartOptions}
                />
              </div>
            </div>
          ) : (
            <div>
              <BeatLoader loading color={'#6f8eaa'} />
            </div>
          )
        }
      </div>
    )
  }
}

export default CellsPerPositionGraph



// WEBPACK FOOTER //
// ./src/routes/QC/components/CellsPerPositionGraph.jsx